import React from 'react';

import UnAuthorizedPage from './UnAuthorizedPage';
import ResetPasswordContainer from '../containers/ResetPasswordContainer';
import UnAuthorizedHeader from '../components/UnAuthorizedHeader'
import translate from '../lib/i18n/translate'

const ResetPasswordPage = (props) => {

    const {ResetHeader, ResetText} = props.strings;

    return (
        <UnAuthorizedPage>
            <UnAuthorizedHeader header={ResetHeader} text={ResetText}/>
            <ResetPasswordContainer />
        </UnAuthorizedPage>
    );
}

export default translate('ResetPasswordPage')(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/pages/ResetPasswordPage.js